import React from "react";
import Layout from "../layouts/Default";
import useApi from "../hooks/useApi";

// Parts
import Hero from "../parts/Home/Hero";
import Image from "../parts/Home/Image";
import HowItWorks from "../parts/Home/HowItWorks";
import Presentation from "../parts/Home/Presentation";
import Events from "../parts/Home/Events";
import PastProjects from "../parts/Home/PastProjects";
import Testimonials from "../parts/Home/Testimonials";
import Video from "../parts/Home/Video";

const sections = {
  hero: props => <Hero {...props} />,
  image: props => <Image {...props} />,
  how_it_works: props => <HowItWorks {...props} />,
  ebd_presentation: props => <Presentation {...props} />,
  events: props => <Events {...props} />,
  past_projects: props => <PastProjects {...props} />,
  testimonials: props => <Testimonials {...props} />,
  video: props => <Video {...props} />,
};

export default () => {
  const { data } = useApi("/pages?slug=home");
  const [{ home_content }] = !data || data.length === 0 ? [{}] : data;

  return (
    <Layout noPadding title="Home">
      {home_content && (
        <div className="pHome">
          {home_content.map(({ name, props }, index) => {
            const Section = sections[name];
            if (Section) return <Section key={index} {...props} />;
            else return null;
          })}
        </div>
      )}
    </Layout>
  );
};
